import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { Link } from "../components"
import { Headphone, HeadphoneWireless } from "../assets/images"
import { BarViz } from "../components"
import { BREAKPOINT } from "../data/uniqueValues"

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100%",
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      height: "100%",
    },
  },
  card: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "75vh",
    width: "100%",
    maxWidth: "1100px",
    boxSizing: "border-box",
    background: colors.yellow,
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      height: "100%",
      paddingBottom: "4rem",
    },
  },
  top: {
    display: "flex",
    marginBottom: "2rem",
    "@media only screen and (max-width: 700px)": {
      flexDirection: "column",
    },
  },
  imgContainer: {
    border: "1px solid red",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    width: "30vw",
    boxSizing: "border-box",
    // maxWidth: "360px",
    margin: "0 2rem",
    // "@media only screen and (max-width: 700px)": {
    //   margin: "1rem 0 1rem 1rem",
    // },
  },
  headphone: {
    // width: "100%",
    // objectFit: "contain",
    width: "30vw",
    boxSizing: "border-box",
    maxWidth: "360px",
    margin: "0 2rem",
    lineHeight: "normal",
    "@media only screen and (max-width: 700px)": {
      margin: "1rem 0 1rem 1rem",
    },
  },
  textContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    marginTop: "2rem",
    padding: "0 3rem",
    "@media only screen and (max-width: 700px)": {
      marginTop: 0,
    },
  },
  heading: {
    color: colors.black,
    fontSize: "calc(30px + (44 - 30) * ((100vw - 300px) / (1600 - 300)))",
    textAlign: "left",
    margin: "0 0 1rem 0",
    lineHeight: "normal",
    background: colors.yellow,
  },
  description: {
    //fontSize: "calc(14px + (24 - 14) * ((100vw - 300px) / (1600 - 300)))",
    fontSize: "20px",
    fontFamily: "Apercu",
    lineHeight: "24px",
    fontWeight: 700,
    textAlign: "left",
    background: colors.yellow,
  },
  start: {
    padding: "1rem 5.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: colors.white,
    border: `2px solid ${colors.white}`,
    color: colors.black,
    transition: `background-color 0.2s ease-in-out,
      color 0.2s ease-in-out,
      border 0.2s ease-in-out`,
    marginLeft: "3.5rem",
    marginBottom: "1rem",
    "&:hover": {
      color: colors.white,
      backgroundColor: colors.black,
      border: `2px solid ${colors.black}`,
    },
    "&:focus": {
      color: colors.white,
      backgroundColor: colors.black,
      border: `2px solid ${colors.black}`,
    },
    "@media only screen and (max-width: 700px)": {
      marginLeft: 0,
    },
  },
  started: {
    composes: "$start",
    color: colors.white,
    backgroundColor: colors.black,
    border: `2px solid ${colors.black}`,
    "&:hover": {},
  },
  startText: {
    fontFamily: "WiredMono",
    fontWeight: 600,
    fontSize: "calc(20px + (26 - 20) * ((100vw - 300px) / (1600 - 300)))",
    margin: 0,
    textDecoration: "none",
    textAlign: "center",
    pointerEvents: "none",
  },
  barViz: {
    position: "absolute",
    margin: 0,
    height: "80px",
    left: "2rem",
    bottom: "-40px",
    display: "block",
  },
  intro: {
    fontFamily: "BreveText, helvetica, sans-serif",
  },
}

const Header = ({
  classes,
  headerCardRef,
  startRef,
  headphoneRef,
  startButtonState,
  startButtonOnClick,
}) => {
  const getClassName = (startButtonState, lockAnswer) => {
    return `${startButtonState === true ? classes.started : classes.start} ${
      !lockAnswer ? classes.hover : ""
    }`
  }

  const keyHandler = ({ code }) => {
    if (code === "Enter") {
      startButtonOnClick()
    }
  }

  return (
    <header className={classes.container}>
      <div className={classes.card} ref={headerCardRef}>
        <div className={classes.top}>
          {/* <Headphone ref={headphoneRef} /> */}
          {/* <div className={classes.imgContainer}> */}
          <img
            className={classes.headphone}
            src={window.innerWidth > 700 ? Headphone : HeadphoneWireless}
            alt="Headphone"
            ref={headphoneRef}
          />
          {/* </div> */}
          <div className={classes.textContainer}>
            <h1 className={classes.heading}>
              Looking for New Headphones or Earbuds? Take Our Quiz
            </h1>
            <p className={classes.description}>
              We’ve tested dozens of over-ear headphones and earbuds. Here’s how
              to find your perfect, WIRED-approved pair.
            </p>
            <p className={classes.intro}>
              This easy quiz has a wide range of results based on our headphone
              testing over the past several years. The algorithm will point you
              toward the best pair of headphones for you, based on your budget,
              wireless preferences, the phone you use, your ear size, and more.
              Answer the questions to find out which musical mates are best for
              you! If you need different pairs for different reasons, just take
              the quiz again. Visit{" "}
              <Link
                url="https://www.wired.com/tag/headphones/"
                text="our many headphone guides and reviews"
              />{" "}
              to look up specifics on every pair we've tested and recommend.
            </p>
          </div>
        </div>
        <div
          className={getClassName(startButtonState)}
          onClick={startButtonOnClick}
          onKeyDown={(e) => keyHandler(e)}
          tabIndex="0"
          ref={startRef}>
          <p className={classes.startText}>START</p>
        </div>
        {/* <button className={classes.start} onClick={scrollToQuiz} ref={startRef}>
          START
        </button> */}
        {window.innerWidth > BREAKPOINT ? (
          <div className={classes.barViz}>
            <BarViz topColor={colors.white} bottomColor={colors.yellow} />
          </div>
        ) : null}
      </div>
    </header>
  )
}

export default withStyles(styles)(Header)
